import { IS_CLIENT } from '@repo/common-utils';

export type IndividualRefundData = {
  authType?: 'simple-auth' | 'joint-certificate' | 'partner-auth';
  corpType: 'INDIS' | 'CORPS';
  refundToken: string;
  regNo?: string;
  serviceAgreementFlow: boolean;
  marketingAgree?: boolean;
  thirdAgree?: boolean;
};

const individualRefundDataKey = 'individual-refund-data';

export function getIndividualRefundData(): IndividualRefundData | undefined {
  if (IS_CLIENT) {
    const item = sessionStorage.getItem(individualRefundDataKey);
    if (item) {
      return JSON.parse(item);
    }
  }

  return undefined;
}

export function setIndividualRefundData(data: IndividualRefundData) {
  if (IS_CLIENT) {
    sessionStorage.setItem(individualRefundDataKey, JSON.stringify(data));
  }
}
